module.exports = __webpack_public_path__ + "static/media/dolby-vision.b4e809e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/appletv-icons/dolby-vision.svg
// module id = 255
// module chunks = 0